import postsSlice from './posts';
import chatsSlice from './chats';
import activeSlice from './active';
import chatMessagesSlice from './chat-messages';

export default {
  postsSlice,
  chatsSlice,
  activeSlice,
  chatMessagesSlice,
};
